import {Component, Inject, Input, OnInit} from '@angular/core';
import {StorageService} from "../../../core/services/storage.service";
import {TranslateService} from "@ngx-translate/core";
import { NgIf } from "@angular/common";
import {CookieService} from "ngx-cookie-service";
import {MeService} from "../../../core/services/me.service";
import {CURRENCY_HEADER, LANGUAGE_HEADER} from "../../../models/server.injects";
import {FormsModule} from "@angular/forms";
import {customSetTimeout} from "../../../core/helpers/overrided-timers";

@Component({
  selector: 'app-language-changer',
  templateUrl: './language-changer.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgIf
  ],
  providers: [MeService],
  styleUrls: ['./language-changer.component.scss']
})
export class LanguageChangerComponent implements OnInit {

  lang: any;
  openMenu: any = false;
  @Input() forPlace: any;
  @Inject(LANGUAGE_HEADER) private languageHeader: any;
  @Inject(CURRENCY_HEADER) private currencyHeader: any;
  classes: any = 'mobile-footer-language';
  constructor(private coockieService: CookieService,
              private me: MeService,
  private translate: TranslateService) { }

  ngOnInit(): void {
    this.lang = StorageService.getItem(StorageService.statics.lang);
    if(!this.lang || this.lang === 'null') this.lang = this.languageHeader;
    if(!this.lang || this.lang === 'null') this.lang = 'en';
    this.translate.setDefaultLang(this.lang);
    this.translate.use(this.lang);
  }
  setLang(event:any){
    StorageService.setItem(StorageService.statics.lang, event);
    let authUser = StorageService.getJsonItem(StorageService.statics.currentUser);
    if(authUser){
      this.me.updateProfile({language: event}).subscribe((e:any)=>{
        this.coockieService.set('language', event, 999999);
        this.translate.setDefaultLang(event);
        this.translate.use(event);
        let profile = StorageService.getJsonItem(StorageService.statics.profileData);
        if(profile){
          profile.language = event;
          StorageService.setJsonItem(StorageService.statics.profileData, profile);
        }
        customSetTimeout(()=>{
          location.reload();
        })

      });
    }else{
      location.reload();
    }
  }

  toogleMenue(){
      this.openMenu = !this.openMenu
  }
}
